import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Button, Header, Image } from '../../models';
import { Media, ResizePipe } from '@teamfoster/sdk/image';
import { RouterLink } from '@angular/router';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-header-article',
  templateUrl: './header-article.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ResizePipe, RouterLink, NgOptimizedImage],
})
export class HeaderArticleComponent {
  @Input() subtitle?: string;
  @Input() title?: string;
  @Input() intro?: string;
  @Input() media?: Media;
  @Input() button?: Button;

  height(height: number | null | undefined): number {
    if (height && height > 800) {
      return 800;
    }
    return height || 800;
  }

  constructor() {}
}
